import React, { Suspense } from 'react'
import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'

export const LoadingLayout = ({
  children,
  loadingScreen,
}: {
  children: React.ReactNode
  loadingScreen?: React.ReactNode
}) => {
  return <Suspense fallback={loadingScreen ?? <LoadingScreen />}>{children}</Suspense>
}

export const LoadingScreen = () => {
  return (
    <CenterScreen>
      <LoadingContent message={`Loading....`} subMessage="Please wait while we are loading the screen..." />
    </CenterScreen>
  )
}
